"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIUM = exports.PREVIEW = exports.THUMB = exports.ICON = void 0;
var ICON = 'icon';
exports.ICON = ICON;
var THUMB = 'thumb';
exports.THUMB = THUMB;
var PREVIEW = 'preview';
exports.PREVIEW = PREVIEW;
var MEDIUM = 'medium';
exports.MEDIUM = MEDIUM;